var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Basic = require("../../../elements/Basic");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Basic/PlayerName.js";

var _default = function _default(_ref) {
  var _ref$isTitle = _ref.isTitle,
      isTitle = _ref$isTitle === void 0 ? true : _ref$isTitle,
      player = _ref.player,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["isTitle", "player"]);
  var playerName;

  if (player && player.nickName) {
    playerName = player.nickName;
  } else if (player && player.firstName && player.lastName) {
    playerName = player.firstName + " " + player.lastName;
  }

  if (playerName) {
    if (isTitle) {
      return _react.default.createElement(_Basic.Title, (0, _extends2.default)({
        numberOfLines: 1
      }, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 15,
          columnNumber: 17
        }
      }), playerName);
    }

    return _react.default.createElement(_Basic.Text, (0, _extends2.default)({
      numberOfLines: 1
    }, rest, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 21,
        columnNumber: 13
      }
    }), playerName);
  }

  return null;
};

exports.default = _default;